import React, { useState, useEffect } from "react";
import { Breadcrumb, SimpleCard } from "@gull";
import { Formik } from "formik";
import { Helmet } from "react-helmet";
// import {
//   addSupplier,
//   memberPageLoaded,
// } from "app/store/actions/SupplierAction";
import config from "config.json";
import {
  model,
  validationModel,
  currencies,
  companyTypes,
  cities,
  countries,
  states,
} from "./addSupplierModel";
import {
  RenderSelectInput,
  RenderTextInput,
  RenderCheckboxInput,
  RenderDateInput,
} from "app/common/renderInput";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import LoadingOverlay from "react-loading-overlay";
import { getMerchant, addMember } from "app/services/memberService";
import queryString from "app/services/queryStringService";
import { getUserGroup } from "app/services/userGroupService";
import DistributorAutoComplete from "./DistributorAutoComplete";
import { NotificationManager } from "react-notifications";

import { useNavigate } from "react-router-dom";

const { autoGenerateUsername } = config;

function AddSupplier() {
  const navigate = useNavigate();

  const [state, setState] = useState({
    model,
    userGroupDetails: null,
    memberTypeOptions: [
      { value: "B2B", label: "B2B" },
      { value: "Member", label: "Member" },
      { value: "Merchant", label: "Merchant" },
    ],
    memberRoleOptions: [
      { value: 1, label: "Admin" },
      { value: 2, label: "Admin User" },
      { value: 3, label: "WLP" },
      { value: 4, label: "Super" },
      { value: 5, label: "Merchant" },
      { value: 6, label: "API User" },
    ],
    booleanSelectOpt: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    directCreditSettingOption: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
    currencyOptions: currencies.map((x, i) => {
      return {
        value: i,
        label: x.cc + " - " + x.symbol,
      };
    }),
    paymentModeOptions: [
      { value: "Direct", label: "Direct" },
      { value: "Indirect", label: "Indirect" },
    ],

    companyTypeOptions: [
      { value: "Proprietorship", label: "Proprietorship" },
      { value: "Partnership/Company", label: "Partnership/Company" },
      { value: "Individual", label: "Individual" },
    ],
    stateOptions: states.map((x, i) => {
      return {
        value: i + 1,
        label: x,
      };
    }),

    countryOptions: countries.map((x, i) => {
      return {
        value: i + 1,
        label: x,
      };
    }),

    merchants: [],
  });

  const pageMount = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: 1,
      pageSize: 50,
    });
    const response = await getMerchant(query);
    const data = response.data.data;
    const merchantsList = data.map((x, i) => {
      return {
        value: x.memId,
        label: x.memberFullName,
      };
    });
    setState((prev) => ({ ...prev, merchants: [...merchantsList] }));
  };

  const userGroupHandler = async () => {
    const userDetails = await getUserGroup();

    setState((prev) => ({
      ...prev,

      userGroupDetails: userDetails.data.data.map((item) => {
        return { value: item.id, label: item.name };
      }),
    }));
  };

  useEffect(() => {
    pageMount();
    userGroupHandler();
  }, []);
  const handleSubmit = async (values, { setSubmitting }) => {
    console.log(values);
    const res = await addMember(values);
    console.log(res);

    if (res.status == "Success") {
      NotificationManager.success(res.message);
      navigate("/admin/supplier-list");
    } else {
      NotificationManager.error(res.message);
    }

    //  props.addSupplier(values);
  };

  return (
    <div>
      <Helmet>
        <title>Add Member</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[
          { name: "Supplier List", path: "/admin/supplier" },
          { name: "Add Supplier" },
        ]}
      ></Breadcrumb>
      <div>
        <Formik
          initialValues={state.model}
          validationSchema={validationModel}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            isValid,
            dirty,
            setFieldValue,
          }) => {
            return (
              <form
                className="needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                {/* <div>
                  <div className="col-md-12">
                    {Object.values(errors).map(msg => (
                      <>
                        {msg}
                        <br />
                      </>
                    ))}
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <SimpleCard title="Personal Details" className="mb-4">
                      <div className="row d-none">
                        <RenderSelectInput
                          name="memberType"
                          display="Member Type"
                          placeholder="Member Type"
                          value={values.memberType}
                          error={errors.memberType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.memberType}
                          items={state.memberTypeOptions}
                          disabled
                          required
                        ></RenderSelectInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="memberFirstName"
                          display="Full Name"
                          placeholder="Full Name"
                          value={values.memberFirstName}
                          error={errors.memberFirstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.memberFirstName}
                          required
                        ></RenderTextInput>
                        {/* <RenderTextInput
                        type="text"
                        name="memberLastName"
                        display="Last Name"
                        placeholder="Last Name"
                        value={values.memberLastName}
                        error={errors.memberLastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.memberLastName}
                        required
                      ></RenderTextInput> */}
                      </div>
                      <div className="row">
                        <RenderSelectInput
                          type="number"
                          name="countryId"
                          display="Country"
                          value={values.countryId}
                          error={errors.countryId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.countryId}
                          items={state.countryOptions}
                        ></RenderSelectInput>
                        <RenderSelectInput
                          type="number"
                          name="stateId"
                          display="State"
                          value={values.stateId}
                          error={errors.stateId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.stateId}
                          items={state.stateOptions}
                        ></RenderSelectInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="city"
                          display="City"
                          placeholder="City"
                          value={values.city}
                          error={errors.city}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.city}
                          required
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="pin"
                          display="ZIP Code"
                          placeholder="ZIP Code"
                          value={values.pin}
                          error={errors.pin}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.pin}
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="email"
                          name="emailId"
                          display="Email"
                          placeholder="Email"
                          value={values.emailId}
                          error={errors.emailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.emailId}
                          required
                        ></RenderTextInput>
                        <RenderTextInput
                          type="email"
                          name="notificationEmailId"
                          display="Notification Email"
                          placeholder="Notification Email"
                          value={values.notificationEmailId}
                          error={errors.notificationEmailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.notificationEmailId}
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="email"
                          name="optionalEmailId"
                          display="Optional Email"
                          placeholder="Optional Email"
                          value={values.optionalEmailId}
                          error={errors.optionalEmailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.optionalEmailId}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="memberMobileNo"
                          display="Member Mobile No"
                          placeholder="Member Mobile No"
                          value={values.memberMobileNo}
                          error={errors.memberMobileNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.memberMobileNo}
                          required
                        ></RenderTextInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="optionalMobileNo"
                          display="Optional Mobile No"
                          placeholder="Optional Mobile No"
                          value={values.optionalMobileNo}
                          error={errors.optionalMobileNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.optionalMobileNo}
                          required
                        ></RenderTextInput>
                        {!autoGenerateUsername && (
                          <RenderTextInput
                            type="text"
                            name="uniqueIdentity"
                            display="Username"
                            placeholder="Username"
                            value={values.uniqueIdentity}
                            error={errors.uniqueIdentity}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.uniqueIdentity}
                            required
                          ></RenderTextInput>
                        )}
                      </div>

                      <div className="row">
                        <RenderSelectInput
                          type="text"
                          name="activeMember"
                          display="Active Member"
                          placeholder="Active Member"
                          value={values.activeMember}
                          error={errors.activeMember}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          items={state.booleanSelectOpt}
                          touched={touched.activeMember}
                          required
                        ></RenderSelectInput>
                        <RenderTextInput
                          type="password"
                          name="password"
                          display="Password"
                          placeholder="Password"
                          value={values.password}
                          error={errors.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.password}
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="resAddress"
                          display="Res Address"
                          placeholder="Res Address"
                          value={values.resAddress}
                          error={errors.resAddress}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.resAddress}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="resPinNo"
                          display="Res Zip Code"
                          placeholder="Res Zip Code"
                          value={values.resPinNo}
                          error={errors.resPinNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.resPinNo}
                        ></RenderTextInput>
                      </div>

                      <div className="row">
                        <RenderDateInput
                          type="date"
                          name="certificateBeganDate"
                          display="Certificate StartDate"
                          placeholder="Certificate StartDate"
                          value={values.certificateBeganDate}
                          error={errors.certificateBeganDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.certificateBeganDate}
                        ></RenderDateInput>
                        <RenderDateInput
                          type="date"
                          name="certificateEndDate"
                          display="Certificate EndDate"
                          placeholder="Certificate EndDate"
                          value={values.certificateEndDate}
                          error={errors.certificateEndDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.certificateEndDate}
                        ></RenderDateInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="certificateMobileNumber"
                          display="Certificate MobileNumber"
                          placeholder="Certificate MobileNumber"
                          value={values.certificateMobileNumber}
                          error={errors.certificateMobileNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.certificateMobileNumber}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="email"
                          name="certificateEmailId"
                          display="certificate EmailId"
                          placeholder="certificate EmailId"
                          value={values.certificateEmailId}
                          error={errors.certificateEmailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.certificateEmailId}
                        ></RenderTextInput>
                      </div>
                      {/* ///////////////// */}
                      <div className="row">
                        {/* <RenderSelectInput
                        
                        name="creditStatus"
                        display="credit Facility"
                        placeholder="credit Facility"
                        value={values.creditStatus}
                        items={ state.booleanSelectOpt}
                        error={errors.creditStatus}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.creditStatus}
                      ></RenderSelectInput> */}

                        {/* <RenderSelectInput
                        name="isCreditLock"
                        display="isCredit Lock"
                        placeholder="isCredit Lock"
                        value={values.isCreditLock}
                        items={ state.booleanSelectOpt}
                        error={errors.isCreditLock}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.isCreditLock}
                      ></RenderSelectInput> */}
                      </div>
                    </SimpleCard>

                    <SimpleCard title="Mapping Details" className="mb-4">
                      <div className="row">
                        <span className="d-none">
                          <RenderSelectInput
                            type="text"
                            name="supportMemberName"
                            display="Support Member Name"
                            placeholder="Support Member Name"
                            value={values.supportMemberName}
                            items={state.booleanSelectOpt}
                            error={errors.supportMemberName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.supportMemberName}
                          ></RenderSelectInput>
                        </span>
                        <RenderTextInput
                          type="text"
                          name="salesMemberName"
                          display="Sales Member Name"
                          placeholder="Sales Member Name"
                          value={values.salesMemberName}
                          error={errors.salesMemberName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.salesMemberName}
                        ></RenderTextInput>
                        <RenderSelectInput
                          name="userGroup"
                          display="User Group"
                          placeholder="User Group"
                          value={values.userGroup}
                          error={errors.userGroup}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.userGroup}
                          items={state.userGroupDetails}
                        ></RenderSelectInput>
                      </div>

                      <div className="row">
                        <div className="col">
                          <label> Introducer Distributor</label>
                          <span className="text-danger"> * </span>
                          <DistributorAutoComplete
                            setFieldValue={setFieldValue}
                            introducerDist={state.introducerDist}
                            handleChangeOptions={(introducerDist) => {
                              setFieldValue("introducerDist", introducerDist);
                              setState({ introducerDist });
                            }}
                            name="introducerDist"
                            value={values.introducerDist}
                            // required
                          />
                          {!values.introducerDist ? (
                            <small className="text-danger">
                              {errors.introducerDist}
                            </small>
                          ) : (
                            ""
                          )}
                        </div>

                        {/* <RenderTextInput
                          type="text"
                          name="introducerSuper"
                          display="Introducer Distributer"
                          placeholder="Introducer Distributer"
                          value={values.introducerSuper}
                          error={errors.introducerSuper}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.introducerSuper}
                          required
                        ></RenderTextInput> */}
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="introducerDist"
                          display="Introducer Dist"
                          placeholder="Introducer Dist"
                          value={values.introducerDist}
                          error={errors.introducerDist}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.introducerDist}
                          required
                          hidden
                        ></RenderTextInput>
                      </div>
                      {/* 
                    <div className="row">
                      <RenderSelectInput
                        name="userGroup"
                        display="User Group"
                        placeholder="User Group"
                        value={values.userGroup}
                        error={errors.userGroup}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.userGroup}
                        items={ state.userGroupDetails}
                        required
                      ></RenderSelectInput>
                    </div> */}
                    </SimpleCard>
                    {/* /////////////////////// */}
                    <SimpleCard title="Tax Details" className="mb-4">
                      <div className="row">
                        <RenderSelectInput
                          type="text"
                          name="gstFlag"
                          display="GST Flag"
                          value={values.gstFlag}
                          items={state.booleanSelectOpt}
                          error={errors.gstFlag}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.gstFlag}
                          // required
                        ></RenderSelectInput>

                        <RenderSelectInput
                          type="text"
                          name="tdsFlag"
                          display="TDS Flag"
                          value={values.tdsFlag}
                          items={state.booleanSelectOpt}
                          error={errors.tdsFlag}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.tdsFlag}
                          //required
                        ></RenderSelectInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="tdsExemtionNo"
                          display="TDS Exemtion No"
                          placeholder="TDS Exemtion No"
                          value={values.tdsExemtionNo}
                          error={errors.tdsExemtionNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.tdsExemtionNo}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="tdsExemtionLimit"
                          display="TDS Exemtion Limit"
                          placeholder="TDS Exemtion Limit"
                          value={values.tdsExemtionLimit}
                          error={errors.tdsExemtionLimit}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.tdsExemtionLimit}
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="tdsExemtionRate"
                          display="TDS Exemtion Rate"
                          placeholder="TDS Exemtion Rate"
                          value={values.tdsExemtionRate}
                          error={errors.tdsExemtionRate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.tdsExemtionRate}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="serviceTaxNo"
                          display="Service Tax No"
                          placeholder="Service Tax No"
                          value={values.serviceTaxNo}
                          error={errors.serviceTaxNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.serviceTaxNo}
                        ></RenderTextInput>
                      </div>
                    </SimpleCard>
                    <SimpleCard
                      title="Promo and Reffer Details"
                      className="mb-4"
                    >
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="supplierPromocode"
                          display="Supplier Promo Code"
                          placeholder="Supplier Promo Code"
                          value={values.supplierPromocode}
                          error={errors.supplierPromocode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.supplierPromocode}
                        ></RenderTextInput>

                        <RenderTextInput
                          type="text"
                          name="refferCode"
                          display="Reffer Code"
                          placeholder="Reffer Code"
                          value={values.refferCode}
                          error={errors.refferCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.refferCode}
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="registerRefferCode"
                          display="Register Reffer Code"
                          placeholder="Register Reffer Code"
                          value={values.registerRefferCode}
                          error={errors.registerRefferCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.registerRefferCode}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="remarks"
                          display="Remarks"
                          placeholder="Remarks"
                          value={values.remarks ? values.remarks : ""}
                          error={errors.remarks}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.remarks}
                        ></RenderTextInput>
                      </div>
                    </SimpleCard>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <SimpleCard title="Company Details" className="mb-4">
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="company"
                          display="Company"
                          placeholder="Company"
                          value={values.company}
                          error={errors.company}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.company}
                          required
                        ></RenderTextInput>

                        <RenderSelectInput
                          type="text"
                          name="companyType"
                          display="Company Type"
                          value={values.companyType}
                          error={errors.companyType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyType}
                          items={state.companyTypeOptions}
                          required
                        ></RenderSelectInput>
                      </div>
                      <div className="row">
                        <RenderSelectInput
                          type="number"
                          name="companyGstCountryId"
                          display="Company GST Country"
                          value={values.companyGstCountryId}
                          error={errors.companyGstCountryId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstCountryId}
                          items={state.countryOptions}
                        ></RenderSelectInput>

                        <RenderTextInput
                          type="text"
                          name="companyPinNo"
                          display="Company Zip Code"
                          placeholder="Company Zip Code"
                          value={values.companyPinNo}
                          error={errors.companyPinNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyPinNo}
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="companyGstNo"
                          display="Company GST No"
                          placeholder="Company GST No"
                          value={values.companyGstNo}
                          error={errors.companyGstNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstNo}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="companyGstMobileNo"
                          display="Company GST Mobile No"
                          placeholder="Company GST Mobile No"
                          value={values.companyGstMobileNo}
                          error={errors.companyGstMobileNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstMobileNo}
                        ></RenderTextInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="email"
                          name="companyGstEmail"
                          display="Company GST Email"
                          placeholder="Company GST Email"
                          value={values.companyGstEmail}
                          error={errors.companyGstEmail}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstEmail}
                        ></RenderTextInput>

                        <RenderSelectInput
                          type="number"
                          name="companyGstStateId"
                          display="Company GST State"
                          value={values.companyGstStateId}
                          error={errors.companyGstStateId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstStateId}
                          items={state.stateOptions}
                        ></RenderSelectInput>
                      </div>
                      <div className="row">
                        <RenderTextInput
                          type="number"
                          name="companyGstPin"
                          display="Company GST Zip"
                          placeholder="Company GST Zip"
                          value={values.companyGstPin}
                          error={errors.companyGstPin}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstPin}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="companyGstCity"
                          display="Company GST City"
                          placeholder="Company GST City"
                          value={values.companyGstCity}
                          error={errors.companyGstCity}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstCity}
                          //required
                        ></RenderTextInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="textarea"
                          name="companyGstAddress"
                          display="Company GST Address"
                          placeholder="Company GST Address"
                          value={values.companyGstAddress}
                          error={errors.companyGstAddress}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyGstAddress}
                          // required
                        ></RenderTextInput>

                        <RenderTextInput
                          type="text"
                          name="companyAddress"
                          display="Company Address"
                          placeholder="Company Address"
                          value={values.companyAddress}
                          error={errors.companyAddress}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.companyAddress}
                          // required
                        ></RenderTextInput>
                      </div>
                    </SimpleCard>
                    <SimpleCard title="Transaction Parameters" className="mb-4">
                      <div className="row">
                        <RenderSelectInput
                          type="text"
                          name="currencyId"
                          display="Currency"
                          placeholder="Currency"
                          value={values.currencyId}
                          error={errors.currencyId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.currencyId}
                          items={state.currencyOptions}
                          required
                        ></RenderSelectInput>

                        <RenderTextInput
                          type="number"
                          name="maxCreditLimit"
                          display="Max Credit Limit"
                          placeholder="Max Credit Limit"
                          value={values.maxCreditLimit}
                          error={errors.maxCreditLimit}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.maxCreditLimit}
                          min="0"
                          required
                        ></RenderTextInput>

                        <span className="d-none">
                          <RenderTextInput
                            type="number"
                            name="blockedBalance"
                            display="Blocked Balance"
                            placeholder="Blocked Balance"
                            value={values.blockedBalance}
                            error={errors.blockedBalance}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.blockedBalance}
                            required
                          ></RenderTextInput>
                        </span>
                      </div>
                      <div className="row">
                        <span className="d-none">
                          <RenderTextInput
                            type="number"
                            name="creditLimit"
                            display="Credit Limit"
                            placeholder="Credit Limit"
                            value={values.creditLimit}
                            error={errors.creditLimit}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.creditLimit}
                            required
                          ></RenderTextInput>

                          <RenderTextInput
                            type="number"
                            name="reservedCreditLimit"
                            display="Reserved Credit Limit"
                            placeholder="Reserved Credit Limit"
                            value={values.reservedCreditLimit}
                            error={errors.reservedCreditLimit}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.reservedCreditLimit}
                            required
                          ></RenderTextInput>
                        </span>
                      </div>
                      <div className="row">
                        <RenderSelectInput
                          type="text"
                          name="paymentMode"
                          display="Payment Mode"
                          value={values.paymentMode}
                          error={errors.paymentMode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.paymentMode}
                          items={state.paymentModeOptions}
                          required
                        ></RenderSelectInput>
                        <RenderSelectInput
                          name="creditStatus"
                          display="Credit Facility"
                          placeholder="Credit Facility"
                          value={values.creditStatus}
                          items={state.booleanSelectOpt}
                          error={errors.creditStatus}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.creditStatus}
                        ></RenderSelectInput>
                      </div>
                      <div className="row">
                        <RenderSelectInput
                          name="isCreditLock"
                          display="Is Credit Lock"
                          placeholder="Is Credit Lock"
                          value={values.isCreditLock}
                          items={state.booleanSelectOpt}
                          error={errors.isCreditLock}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.isCreditLock}
                        ></RenderSelectInput>
                        <RenderSelectInput
                          type="text"
                          name="directCreditSetting"
                          display="Auto Credit"
                          placeholder="Auto Credit"
                          value={values.directCreditSetting}
                          items={state.directCreditSettingOption}
                          error={errors.directCreditSetting}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.directCreditSetting}
                        ></RenderSelectInput>
                      </div>
                    </SimpleCard>
                    <SimpleCard title="KYC Details" className="mb-4 w-100">
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="aadhaarNo"
                          display="Aadhaar No"
                          placeholder="Aadhaar No"
                          value={values.aadhaarNo}
                          error={errors.aadhaarNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.aadhaarNo}
                          // required
                        ></RenderTextInput>

                        <RenderTextInput
                          type="text"
                          name="panNo"
                          display="Pan No"
                          placeholder="Pan No"
                          value={values.panNo.toUpperCase()}
                          error={errors.panNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.panNo}
                          //required
                        ></RenderTextInput>
                      </div>
                      <div className="row">
                        <span className="d-none">
                          <RenderTextInput
                            type="text"
                            name="aadhaarFileName"
                            display="Aadhaar File"
                            placeholder="Aadhaar File"
                            value={values.aadhaarFileName}
                            error={errors.aadhaarFileName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.aadhaarFileName}
                            //required
                          ></RenderTextInput>
                          <RenderTextInput
                            type="text"
                            name="panFileName"
                            display="Pan File"
                            placeholder="Pan File"
                            value={values.panFileName}
                            error={errors.panFileName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.panFileName}
                            // required
                          ></RenderTextInput>
                        </span>
                      </div>
                    </SimpleCard>
                    <SimpleCard title="Registration Details" className="mb-4">
                      {/* <div className="row">
                      <RenderTextInput
                        type="date"
                        name="joiningDate"
                        display="Joining Date"
                        placeholder="Joining Date"
                        value={values.joiningDate}
                        error={errors.joiningDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.joiningDate}
                        required
                      ></RenderTextInput>

                      <RenderTextInput
                        type="date"
                        name="renewalDate"
                        display="Renewal Date"
                        placeholder="Renewal Date"
                        value={values.renewalDate}
                        error={errors.renewalDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.renewalDate}
                        required
                      ></RenderTextInput>
                    </div> */}
                      <div className="row">
                        <RenderCheckboxInput
                          type="switch"
                          name="isMerchantInvoiceLogo"
                          display="Is Merchant Invoice Logo"
                          placeholder="Is Merchant Invoice Logo"
                          value={values.isMerchantInvoiceLogo}
                          error={errors.isMerchantInvoiceLogo}
                          onChange={(e) => {
                            setFieldValue(
                              "isMerchantInvoiceLogo",
                              e.currentTarget.checked
                            );
                          }}
                          onBlur={handleBlur}
                          touched={touched.isMerchantInvoiceLogo}
                        ></RenderCheckboxInput>

                        <RenderCheckboxInput
                          type="switch"
                          name="isCorporate"
                          display="Is Corporate"
                          placeholder="Is Corporate"
                          value={values.isCorporate}
                          error={errors.isCorporate}
                          onChange={(e) => {
                            setFieldValue(
                              "isCorporate",
                              e.currentTarget.checked
                            );
                          }}
                          onBlur={handleBlur}
                          touched={touched.isCorporate}
                        ></RenderCheckboxInput>
                      </div>

                      <div className="row">
                        <RenderCheckboxInput
                          type="switch"
                          name="isCharterFlight"
                          display="Is Charter Flight"
                          placeholder="Is Charter Flight"
                          value={values.isCharterFlight}
                          error={errors.isCharterFlight}
                          onChange={(e) => {
                            setFieldValue(
                              "isCharterFlight",
                              e.currentTarget.checked
                            );
                          }}
                          onBlur={handleBlur}
                          touched={touched.isCharterFlight}
                        ></RenderCheckboxInput>

                        <RenderTextInput
                          type="text"
                          name="corpDomesticBufferAmount"
                          display="Corp Domestic Buffer Amount"
                          placeholder="Corp Domestic Buffer Amount"
                          value={values.corpDomesticBufferAmount}
                          error={errors.corpDomesticBufferAmount}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.corpDomesticBufferAmount}
                        ></RenderTextInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="searchRatio"
                          display="Search Ratio"
                          placeholder="Search Ratio"
                          value={values.searchRatio}
                          error={errors.searchRatio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.searchRatio}
                        ></RenderTextInput>

                        <RenderTextInput
                          type="text"
                          name="bookRatio"
                          display="Book Ratio"
                          placeholder="Book Ratio"
                          value={values.bookRatio}
                          error={errors.bookRatio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.bookRatio}
                        ></RenderTextInput>
                      </div>
                    </SimpleCard>
                    <SimpleCard title="Social Details" className="mb-4">
                      <div className="row">
                        <RenderTextInput
                          type="text"
                          name="facebookId"
                          display="Facebook Id"
                          placeholder="Facebook Id"
                          value={values.facebookId}
                          error={errors.facebookId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.facebookId}
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="websiteName"
                          display="Website Name"
                          placeholder="Website Name"
                          value={values.websiteName}
                          error={errors.websiteName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.websiteName}
                        ></RenderTextInput>
                      </div>
                    </SimpleCard>
                    {/* <SimpleCard title="KYC Details" className="mb-4">
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="aadhaarNo"
                        display="Aadhaar No"
                        placeholder="Aadhaar No"
                        value={values.aadhaarNo}
                        error={errors.aadhaarNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.aadhaarNo}
                        // required
                      ></RenderTextInput>

                      <RenderTextInput
                        type="text"
                        name="panNo"
                        display="Pan No"
                        placeholder="Pan No"
                        value={values.panNo}
                        error={errors.panNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.panNo}
                        //required
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <span className="d-none">
                        <RenderTextInput
                          type="text"
                          name="aadhaarFileName"
                          display="Aadhaar File"
                          placeholder="Aadhaar File"
                          value={values.aadhaarFileName}
                          error={errors.aadhaarFileName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.aadhaarFileName}
                          //required
                        ></RenderTextInput>
                        <RenderTextInput
                          type="text"
                          name="panFileName"
                          display="Pan File"
                          placeholder="Pan File"
                          value={values.panFileName}
                          error={errors.panFileName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.panFileName}
                          // required
                        ></RenderTextInput>
                      </span>
                    </div>
                  </SimpleCard> */}
                  </div>
                </div>

                {/* <div className="row">
                <div className="col-lg-6 col-md-12 ">
                  <SimpleCard title="Personal Details" className="mb-4">
                    <div className="row">
                      <RenderSelectInput
                        name="memberType"
                        display="Member Type"
                        placeholder="Member Type"
                        value={values.memberType}
                        error={errors.memberType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.memberType}
                        items={ state.memberTypeOptions}
                        disabled
                        required
                      ></RenderSelectInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="memberFirstName"
                        display="First Name"
                        placeholder="First Name"
                        value={values.memberFirstName}
                        error={errors.memberFirstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.memberFirstName}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="memberLastName"
                        display="Last Name"
                        placeholder="Last Name"
                        value={values.memberLastName}
                        error={errors.memberLastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.memberLastName}
                        required
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderSelectInput
                        type="number"
                        name="countryId"
                        display="Country"
                        value={values.countryId}
                        error={errors.countryId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.countryId}
                        items={ state.countries}
                      ></RenderSelectInput>
                      <RenderSelectInput
                        type="number"
                        name="stateId"
                        display="State"
                        value={values.stateId}
                        error={errors.stateId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.stateId}
                        items={ state.states}
                      ></RenderSelectInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="city"
                        display="City"
                        placeholder="City"
                        value={values.city}
                        error={errors.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.city}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="number"
                        name="pin"
                        display="ZIP Code"
                        placeholder="ZIP Code"
                        value={values.pin}
                        error={errors.pin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.pin}
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="email"
                        name="emailId"
                        display="Email"
                        placeholder="Email"
                        value={values.emailId}
                        error={errors.emailId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.emailId}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="memberMobileNo"
                        display="Member Mobile No"
                        placeholder="Member Mobile No"
                        value={values.memberMobileNo}
                        error={errors.memberMobileNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.memberMobileNo}
                        required
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="email"
                        name="notificationEmailId"
                        display="Notification Email"
                        placeholder="Notification Email"
                        value={values.notificationEmailId}
                        error={errors.notificationEmailId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.notificationEmailId}
                      ></RenderTextInput>

                      <RenderTextInput
                        type="email"
                        name="optionalEmailId"
                        display="Optional Email"
                        placeholder="Optional Email"
                        value={values.optionalEmailId}
                        error={errors.optionalEmailId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.optionalEmailId}
                      ></RenderTextInput>
                    </div>

                    <div className="row">
                      <RenderSelectInput
                        type="number"
                        name="memberRole"
                        display="Member Role"
                        value={values.memberRole}
                        error={errors.memberRole}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.memberRole}
                        items={ state.memberRoleOptions}
                        required
                      ></RenderSelectInput>
                    </div>
                    <div className="row">
                      <RenderSelectInput
                        type="text"
                        name="activeMember"
                        display="Active Member"
                        placeholder="Active Member"
                        value={values.activeMember}
                        error={errors.activeMember}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        items={ state.booleanSelectOpt}
                        touched={touched.activeMember}
                        required
                      ></RenderSelectInput>
                      <RenderTextInput
                        type="text"
                        name="oldMemberId"
                        display="Old Member Id"
                        placeholder="Old Member Id"
                        value={values.oldMemberId}
                        error={errors.oldMemberId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.oldMemberId}
                        required
                      ></RenderTextInput>
                    </div>

                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="resAddress"
                        display="Res Address"
                        placeholder="Res Address"
                        value={values.resAddress}
                        error={errors.resAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.resAddress}
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="resPinNo"
                        display="Res Zip Code"
                        placeholder="Res Zip Code"
                        value={values.resPinNo}
                        error={errors.resPinNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.resPinNo}
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>

                <div className="col-lg-6 col-md-12">
                  <SimpleCard title="Company Details" className="mb-4">
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="company"
                        display="Company"
                        placeholder="Company"
                        value={values.company}
                        error={errors.company}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.company}
                        required
                      ></RenderTextInput>

                      <RenderSelectInput
                        type="text"
                        name="companyType"
                        display="Company Type"
                        value={values.companyType}
                        error={errors.companyType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyType}
                        items={ state.companyTypeOptions}
                        required
                      ></RenderSelectInput>
                    </div>
                    <div className="row">
                      <RenderSelectInput
                        type="number"
                        name="companyGstCountryId"
                        display="Company GST Country"
                        value={values.companyGstCountryId}
                        error={errors.companyGstCountryId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstCountryId}
                        items={ state.countries}
                      ></RenderSelectInput>

                      <RenderTextInput
                        type="text"
                        name="companyPinNo"
                        display="Company Zip Code"
                        placeholder="Company Zip Code"
                        value={values.companyPinNo}
                        error={errors.companyPinNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyPinNo}
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="companyGstNo"
                        display="Company GST No"
                        placeholder="Company GST No"
                        value={values.companyGstNo}
                        error={errors.companyGstNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstNo}
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="companyGstMobileNo"
                        display="Company GST Mobile No"
                        placeholder="Company GST Mobile No"
                        value={values.companyGstMobileNo}
                        error={errors.companyGstMobileNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstMobileNo}
                      ></RenderTextInput>
                    </div>

                    <div className="row">
                      <RenderTextInput
                        type="email"
                        name="companyGstEmail"
                        display="Company GST Email"
                        placeholder="Company GST Email"
                        value={values.companyGstEmail}
                        error={errors.companyGstEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstEmail}
                      ></RenderTextInput>

                      <RenderSelectInput
                        type="number"
                        name="companyGstStateId"
                        display="Company GST State"
                        value={values.companyGstStateId}
                        error={errors.companyGstStateId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstStateId}
                        items={ state.states}
                      ></RenderSelectInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="number"
                        name="companyGstPin"
                        display="Company GST Zip"
                        placeholder="Company GST Zip"
                        value={values.companyGstPin}
                        error={errors.companyGstPin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstPin}
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="companyGstCity"
                        display="Company GST City"
                        placeholder="Company GST City"
                        value={values.companyGstCity}
                        error={errors.companyGstCity}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstCity}
                        required
                      ></RenderTextInput>
                    </div>

                    <div className="row">
                      <RenderTextInput
                        type="textarea"
                        name="companyGstAddress"
                        display="Company GST Address"
                        placeholder="Company GST Address"
                        value={values.companyGstAddress}
                        error={errors.companyGstAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyGstAddress}
                        required
                      ></RenderTextInput>

                      <RenderTextInput
                        type="text"
                        name="companyAddress"
                        display="Company Address"
                        placeholder="Company Address"
                        value={values.companyAddress}
                        error={errors.companyAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.companyAddress}
                        required
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>

                <div className="col-lg-6 col-md-12">
                  <SimpleCard title="Mapping Details" className="mb-4">
                    <div className="row">
                      <RenderSelectInput
                        type="text"
                        name="supportMemberName"
                        display="Support Member Name"
                        placeholder="Support Member Name"
                        value={values.supportMemberName}
                        error={errors.supportMemberName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.supportMemberName}
                      ></RenderSelectInput>
                      <RenderTextInput
                        type="text"
                        name="salesMemberName"
                        display="Sales Member Name"
                        placeholder="Sales Member Name"
                        value={values.salesMemberName}
                        error={errors.salesMemberName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.salesMemberName}
                      ></RenderTextInput>
                    </div>
                    <div className="row"></div>

                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="underWhiteLevel"
                        display="Under White Level"
                        placeholder="Under White Level"
                        value={values.underWhiteLevel}
                        error={errors.underWhiteLevel}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.underWhiteLevel}
                        required
                      ></RenderTextInput>

                      <RenderTextInput
                        type="text"
                        name="introducerSuper"
                        display="Introducer Super"
                        placeholder="Introducer Super"
                        value={values.introducerSuper}
                        error={errors.introducerSuper}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.introducerSuper}
                        required
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="introducerDist"
                        display="Introducer Dist"
                        placeholder="Introducer Dist"
                        value={values.introducerDist}
                        error={errors.introducerDist}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.introducerDist}
                        required
                        hidden
                      ></RenderTextInput>
                    </div>

                    <div className="row">
                      <RenderTextInput
                        name="userGroup"
                        display="User Group"
                        placeholder="User Group"
                        value={values.userGroup}
                        error={errors.userGroup}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.userGroup}
                        items={ state.userGroups}
                        required
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>

                <div className="col-lg-6 col-md-12">
                  <SimpleCard
                    title="Transaction Parameters"
                    className="mb-4"
                  >
                    <div className="row">
                      <RenderSelectInput
                        type="text"
                        name="currencyId"
                        display="Currency"
                        placeholder="Currency"
                        value={values.currencyId}
                        error={errors.currencyId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.currencyId}
                        items={ state.currencyOptions}
                        required
                      ></RenderSelectInput>

                      <RenderTextInput
                        type="number"
                        name="blockedBalance"
                        display="Blocked Balance"
                        placeholder="Blocked Balance"
                        value={values.blockedBalance}
                        error={errors.blockedBalance}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.blockedBalance}
                        required
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="number"
                        name="creditLimit"
                        display="Credit Limit"
                        placeholder="Credit Limit"
                        value={values.creditLimit}
                        error={errors.creditLimit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.creditLimit}
                        required
                      ></RenderTextInput>

                      <RenderTextInput
                        type="number"
                        name="reservedCreditLimit"
                        display="Reserved Credit Limit"
                        placeholder="Reserved Credit Limit"
                        value={values.reservedCreditLimit}
                        error={errors.reservedCreditLimit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.reservedCreditLimit}
                        required
                      ></RenderTextInput>
                    </div>
                   
                  </SimpleCard>
                </div>

                <div className="col-lg-12 col-md-12">
                  <SimpleCard title="KYC Details" className="mb-4">
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="aadhaarNo"
                        display="Aadhaar No"
                        placeholder="Aadhaar No"
                        value={values.aadhaarNo}
                        error={errors.aadhaarNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.aadhaarNo}
                        required
                      ></RenderTextInput>

                      <RenderTextInput
                        type="text"
                        name="panNo"
                        display="Pan No"
                        placeholder="Pan No"
                        value={values.panNo}
                        error={errors.panNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.panNo}
                        required
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="aadhaarFileName"
                        display="Aadhaar File"
                        placeholder="Aadhaar File"
                        value={values.aadhaarFileName}
                        error={errors.aadhaarFileName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.aadhaarFileName}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="panFileName"
                        display="Pan File"
                        placeholder="Pan File"
                        value={values.panFileName}
                        error={errors.panFileName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.panFileName}
                        required
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>

                <div className="col-lg-6 col-md-12">
                  <SimpleCard title="Tax Details" className="mb-4">
                    <div className="row">
                      <RenderSelectInput
                        type="text"
                        name="gstFlag"
                        display="GST Flag"
                        value={values.gstFlag}
                        error={errors.gstFlag}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.gstFlag}
                        required
                      ></RenderSelectInput>

                      <RenderSelectInput
                        type="text"
                        name="tdsFlag"
                        display="TDS Flag"
                        value={values.tdsFlag}
                        error={errors.tdsFlag}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.tdsFlag}
                        required
                      ></RenderSelectInput>
                    </div>

                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="tdsExemtionNo"
                        display="TDS Exemtion No"
                        placeholder="TDS Exemtion No"
                        value={values.tdsExemtionNo}
                        error={errors.tdsExemtionNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.tdsExemtionNo}
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="tdsExemtionLimit"
                        display="TDS Exemtion Limit"
                        placeholder="TDS Exemtion Limit"
                        value={values.tdsExemtionLimit}
                        error={errors.tdsExemtionLimit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.tdsExemtionLimit}
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="tdsExemtionRate"
                        display="TDS Exemtion Rate"
                        placeholder="TDS Exemtion Rate"
                        value={values.tdsExemtionRate}
                        error={errors.tdsExemtionRate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.tdsExemtionRate}
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="serviceTaxNo"
                        display="Service Tax No"
                        placeholder="Service Tax No"
                        value={values.serviceTaxNo}
                        error={errors.serviceTaxNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.serviceTaxNo}
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>

                <div className="col-lg-6 col-md-12">
                  <SimpleCard
                    title="Registration Details"
                    className="mb-4"
                  >
                    
                    </div>
                    <div className="row">
                      <RenderCheckboxInput
                        name="isMerchantInvoiceLogo"
                        display="Is Merchant Invoice Logo"
                        placeholder="Is Merchant Invoice Logo"
                        value={values.isMerchantInvoiceLogo}
                        error={errors.isMerchantInvoiceLogo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.isMerchantInvoiceLogo}
                      ></RenderCheckboxInput>
                      <RenderCheckboxInput
                        name="isCorporate"
                        display="Is Corporate"
                        placeholder="Is Corporate"
                        value={values.isCorporate}
                        error={errors.isCorporate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.isCorporate}
                      ></RenderCheckboxInput>
                    </div>

                    <div className="row">
                      <RenderCheckboxInput
                        name="isCharterFlight"
                        display="Is Charter Flight"
                        placeholder="Is Charter Flight"
                        value={values.isCharterFlight}
                        error={errors.isCharterFlight}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.isCharterFlight}
                      ></RenderCheckboxInput>

                      <RenderTextInput
                        type="text"
                        name="corpDomesticBufferAmount"
                        display="Corp Domestic Buffer Amount"
                        placeholder="Corp Domestic Buffer Amount"
                        value={values.corpDomesticBufferAmount}
                        error={errors.corpDomesticBufferAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.corpDomesticBufferAmount}
                      ></RenderTextInput>
                    </div>

                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="searchRatio"
                        display="Search Ratio"
                        placeholder="Search Ratio"
                        value={values.searchRatio}
                        error={errors.searchRatio}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.searchRatio}
                      ></RenderTextInput>

                      <RenderTextInput
                        type="text"
                        name="bookRatio"
                        display="Book Ratio"
                        placeholder="Book Ratio"
                        value={values.bookRatio}
                        error={errors.bookRatio}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.bookRatio}
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>

                <div className="col-lg-6 col-md-12">
                  <SimpleCard
                    title="Promo and Reffer Details"
                    className="mb-4"
                  >
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="supplierPromocode"
                        display="Supplier Promo Code"
                        placeholder="Supplier Promo Code"
                        value={values.supplierPromocode}
                        error={errors.supplierPromocode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.supplierPromocode}
                      ></RenderTextInput>

                      <RenderTextInput
                        type="text"
                        name="refferCode"
                        display="Reffer Code"
                        placeholder="Reffer Code"
                        value={values.refferCode}
                        error={errors.refferCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.refferCode}
                      ></RenderTextInput>
                    </div>
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="registerRefferCode"
                        display="Register Reffer Code"
                        placeholder="Register Reffer Code"
                        value={values.registerRefferCode}
                        error={errors.registerRefferCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.registerRefferCode}
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="remarks"
                        display="Remarks"
                        placeholder="Remarks"
                        value={values.remarks ? values.remarks : ""}
                        error={errors.remarks}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.remarks}
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>
                <div className="col-lg-6 col-md-12">
                  <SimpleCard title="Social Details" className="mb-4">
                    <div className="row">
                      <RenderTextInput
                        type="text"
                        name="facebookId"
                        display="Facebook Id"
                        placeholder="Facebook Id"
                        value={values.facebookId}
                        error={errors.facebookId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.facebookId}
                      ></RenderTextInput>
                      <RenderTextInput
                        type="text"
                        name="websiteName"
                        display="Website Name"
                        placeholder="Website Name"
                        value={values.websiteName}
                        error={errors.websiteName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.websiteName}
                      ></RenderTextInput>
                    </div>
                  </SimpleCard>
                </div>
              </div> */}

                {/* hidden  */}
                <div className="d-none">
                  <RenderTextInput
                    type="number"
                    name="balance"
                    placeholder="Balance"
                    value={values.balance}
                    error={errors.balance}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.balance}
                  ></RenderTextInput>
                  <RenderTextInput
                    type="number"
                    name="rdsWalletBalance"
                    placeholder="Rds Wallet Balance"
                    value={values.rdsWalletBalance}
                    error={errors.rdsWalletBalance}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.rdsWalletBalance}
                  ></RenderTextInput>
                  <RenderTextInput
                    type="number"
                    name="rdsBlockedBalance"
                    placeholder="Rds Blocked Balance"
                    value={values.rdsBlockedBalance}
                    error={errors.rdsBlockedBalance}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.rdsBlockedBalance}
                  ></RenderTextInput>
                  <RenderTextInput
                    type="number"
                    name="commissionWallet"
                    placeholder="Commission Wallet"
                    value={values.commissionWallet}
                    error={errors.commissionWallet}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.commissionWallet}
                  ></RenderTextInput>
                  <RenderTextInput
                    type="number"
                    name="aepsPayoutBalance"
                    placeholder="Aeps Payout Balance"
                    value={values.aepsPayoutBalance}
                    error={errors.aepsPayoutBalance}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.aepsPayoutBalance}
                  ></RenderTextInput>
                  <RenderTextInput
                    type="number"
                    name="aepsWalletBalance"
                    placeholder="Aeps Wallet Balance"
                    value={values.aepsWalletBalance}
                    error={errors.aepsWalletBalance}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.aepsWalletBalance}
                  ></RenderTextInput>

                  <RenderTextInput
                    type="number"
                    name="aepsBlockedBalance"
                    placeholder="Aeps Blocked Balance"
                    value={values.aepsBlockedBalance}
                    error={errors.aepsBlockedBalance}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.aepsBlockedBalance}
                  ></RenderTextInput>
                  <RenderTextInput
                    type="text"
                    name="bbpsId"
                    display="BBPS Id"
                    placeholder="BBPS Id"
                    value={values.bbpsId}
                    error={errors.bbpsId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.bbpsId}
                    required
                  ></RenderTextInput>
                </div>
                <button
                  // disabled={!(dirty ? isValid)}
                  className="btn pull-right btn-primary mb-3"
                  type="submit"
                >
                  Add Supplier
                </button>
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default AddSupplier;
